import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'

export default makeStyles((theme: Theme) => ({
  message: {
    flex: 1
  },

  buttonsContainer: {
    flex: '0 0 auto',
    display: 'flex',
    justifyContent: 'flex-end'
  },

  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: theme.colors.gray14,
    fontFamily: theme.corporate.primaryFont,
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '18px',
    padding: 0,

    '& h3': {
      color: theme.corporate.primaryColor,
      fontSize: '18px',
      lineHeight: '20px',
      margin: 0,
      padding: 0
    }
  },

  datos: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(3),
    border: `1px solid ${theme.colors.gray600}`,
    borderRadius: '8px',
    marginTop: theme.spacing(2)
  },

  body: {
    // display: 'flex',
    // alignItems: 'flex-start',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(1, 0, 0, 0),

    color: theme.colors.gray14,
    fontFamily: theme.corporate.primaryFont,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',

    '& > div': {
      flex: 1
    }
  },

  wrapperClassification: {
    marginBottom: theme.spacing(3)
  },

  lexonClassification: {
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing(1, 0),
    padding: theme.spacing(0.5),
    color: theme.colors.gray14,
    fontSize: 14,
    backgroundColor: theme.colors.gray50,
    fontFamily: theme.corporate.primaryFont
  },

  lexonClassificationRow: {
    flex: '1 1 auto'
  },

  lexonClassificationButton: {
    flex: '0 0 auto'
  },

  loaderWrap: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4)
  },

  adjuntos: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',

    '& > div': {
      flex: '0 1 auto',
      overflow: 'hidden'
    }
  },

  downloadAlert: {
    marginBottom: theme.spacing(3)
  },

  downloadLoarder: {
    marginLeft: theme.spacing(0.5)
  },

  header: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2)
  },

  headerName: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    marginRight: theme.spacing(2)
  },

  editExpedientButton: {
    marginLeft: 0,
    color: theme.corporate.primaryColor,
    fontSize: 14,

    '& .MuiSvgIcon-root': {
      fontSize: 16
    }
  },

  subsanacion: {
    marginTop: theme.spacing(0.5)
  }
}))
